export enum DateRangeOption {
  TODAY = "today",
  YESTERDAY = "yesterday",
  LAST_7_DAYS = "last7Days",
  LAST_30_DAYS = "last30Days",
  LAST_90_DAYS = "last90Days",
  THIS_MONTH = "thisMonth",
  LAST_MONTH = "lastMonth",
  LAST_12_MONTHS = "last12Months",
  CUSTOM = "custom",
}

export enum TimeField {
  FROM = "timeFromHour",
  TO = "timeToHour",
}
